import { getStorageItem, setStorageItem } from 'utils/storage';

/** Identificador com que as telas abrem o aviso: `showModal(TASKS_PENDING_APPROVAL_MODAL_ID)`. */
export const TASKS_PENDING_APPROVAL_MODAL_ID = 'tasks-pending-approval-participants-modal';

const READ_NOTIFICATIONS_KEY = 'participant_notifications_read';

type PendingTask = { _id: string };

/** Alguma participação pendente ainda não foi vista: é o que abre o aviso sozinho. */
export function hasUnreadTask(tasks: PendingTask[]): boolean {
  const read = getStorageItem(READ_NOTIFICATIONS_KEY);

  return tasks.some(task => !Array.isArray(read) || !read.includes(task._id));
}

/** Soma as participações às já vistas, sem repetir, para o aviso não abrir de novo por elas. */
export function markTasksAsRead(tasks: PendingTask[]): void {
  const read = getStorageItem(READ_NOTIFICATIONS_KEY);
  const taskIds = tasks.map(task => task._id);

  setStorageItem(READ_NOTIFICATIONS_KEY, Array.from(new Set([...(Array.isArray(read) ? read : []), ...taskIds])));
}
